var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdeDashbord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 4.25H5.75C4.92157 4.25 4.25 4.92157 4.25 5.75V10.25C4.25 11.0784 4.92157 11.75 5.75 11.75H10.25C11.0784 11.75 11.75 11.0784 11.75 10.25V5.75C11.75 4.92157 11.0784 4.25 10.25 4.25Z",
    fill: "#002C3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13.25H5.75C4.92157 13.25 4.25 13.9216 4.25 14.75V19.25C4.25 20.0784 4.92157 20.75 5.75 20.75H10.25C11.0784 20.75 11.75 20.0784 11.75 19.25V14.75C11.75 13.9216 11.0784 13.25 10.25 13.25Z",
    fill: "#002C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 4.25H14.75C13.9216 4.25 13.25 4.92157 13.25 5.75V10.25C13.25 11.0784 13.9216 11.75 14.75 11.75H19.25C20.0784 11.75 20.75 11.0784 20.75 10.25V5.75C20.75 4.92157 20.0784 4.25 19.25 4.25Z",
    fill: "#002C3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.25H14.75C13.9216 13.25 13.25 13.9216 13.25 14.75V19.25C13.25 20.0784 13.9216 20.75 14.75 20.75H19.25C20.0784 20.75 20.75 20.0784 20.75 19.25V14.75C20.75 13.9216 20.0784 13.25 19.25 13.25Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdeDashbord);
export default __webpack_public_path__ + "static/media/SdeDashbord.0fa212bb8f82eb1358969cd14739f267.svg";
export { ForwardRef as ReactComponent };